/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnimalProgressValue } from '../../models/animal-progress-value';

export interface FindAnimalProgressValuesByAnimalId$Params {
  animalId: string;
}

export function findAnimalProgressValuesByAnimalId(http: HttpClient, rootUrl: string, params: FindAnimalProgressValuesByAnimalId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AnimalProgressValue>>> {
  const rb = new RequestBuilder(rootUrl, findAnimalProgressValuesByAnimalId.PATH, 'get');
  if (params) {
    rb.path('animalId', params.animalId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AnimalProgressValue>>;
    })
  );
}

findAnimalProgressValuesByAnimalId.PATH = '/api/mh/animal-progress-value/animal/{animalId}';
